import React from 'react';
import CardWithStatus from './components/CardWithStatus/CardWithStatus';
import TimesheetMobileCard from './components/TimesheetMobileCard/TimesheetMobileCard';
import classes from './TNECardsList.module.scss';
import ExpenseMobileCard from './components/ExpenseMobileCard/ExpenseMobileCard';

export default function TNECardsList(props) {
  const { type, data, clickHandler, isLoading, loadingComponent } = props;

  const getComponentByType = (componentType, info) => {
    switch (componentType) {
      case 'timesheet':
        return <TimesheetMobileCard info={info} />;
      case 'expense':
        return <ExpenseMobileCard info={info} />;
      default:
        return false;
    }
  };

  return (
    <div className={classes.listContainer}>
      {!isLoading
        ? data?.map((item) => (
            <CardWithStatus
              clickHandler={() => clickHandler(item.Id)}
              key={item.Id}
              status={item?.Status?.Status.toLowerCase()}
            >
              {getComponentByType(type, item)}
            </CardWithStatus>
          ))
        : loadingComponent}
    </div>
  );
}
